import { ToggleGroup } from '@/components/ui/daisy';
import { QuestionTypeEnum } from '@/models/Question';
import { QuizAnswerOption } from '@/components/question/view/primitives/standard/QuizAnswerOption';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useQuizAnswerView } from '@/components/question/view/typologies/quiz/useQuizAnswerView';

export function QuizAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.QUIZ>,
) {
  const { options, selectedValues, handleChange, disabled } =
    useQuizAnswerView(props);

  return (
    <ToggleGroup
      value={selectedValues.at(0) ?? ''}
      onChange={value => handleChange([value])}
      className="w-full gap-6 rounded-2xl px-4 py-6 flex flex-col"
    >
      {options.map(option => (
        <QuizAnswerOption key={option.id} option={option} disabled={disabled} />
      ))}
    </ToggleGroup>
  );
}
